module.exports = __webpack_public_path__ + "static/media/video_consent_audio_eng.035092ee.mp3";